// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sizes_container[data-v-88d95e6a]{max-height:100px;overflow-y:auto}.ll_item[data-v-88d95e6a]{border:2px solid var(--v-item_instances-lighten1);margin:0 5px}", ""]);
// Exports
module.exports = exports;
